// supplierService.js
import { AccountsAPI } from "api/axios.config";

const SUPPLIERS_CATEGORY_BASE = "/suppliers/categories";

const getSupplierCategories = async ({
  orderBy,
  active,
  search,
  fields,
} = {}) => {
  const params = new URLSearchParams();

  if (orderBy) params.append("OrderBy", orderBy);
  if (typeof active === "boolean") params.append("Active", active);
  if (search) params.append("Search", search);
  if (fields?.length) params.append("Fields", fields.join(","));

  const url = `${SUPPLIERS_CATEGORY_BASE}?${params.toString()}`;
  const res = await AccountsAPI.get(url);
  return res?.data?.data || [];
};

const createSupplierCategory = async (categoryData) => {
  const res = await AccountsAPI.post(`${SUPPLIERS_CATEGORY_BASE}`, {
    data: categoryData,
  });
  return res?.data;
};

const updateSupplierCategory = async (id, categoryData) => {
  const res = await AccountsAPI.patch(`${SUPPLIERS_CATEGORY_BASE}/${id}`, {
    data: categoryData,
  });
  return res?.data;
};

const addSupplierCategory = async (data) => {
  return createSupplierCategory(data);
};

export {
  getSupplierCategories,
  createSupplierCategory,
  updateSupplierCategory,
  addSupplierCategory,
};
